import React from "react";
import "./default.module.scss";

export function Loader() {
	return (
		<div className="loader-wrapper">
			<div className="loader-image-wrapper">
				<div className="loader-image" />
			</div>
			<p className="loader-text">We're just working on your style list</p>
		</div>
	);
}
